export default __webpack_public_path__ + "static/media/Suhas Thakur.6b9b084f.jpg";